// configs
import { componentConfig } from './components';
import { intlConfig } from './intl';
import { pagesMap, pageComponents } from './pages';

// providers
import { StoreProvider } from "@hmpu/powerups.store";
import { IntlProvider } from "@hmpu/powerups.intl.provider";
import { PageConfigProvider } from "@hmpu/powerups.config.page.provider";
import { AudioProvider } from "@hmpu/powerups.audio.provider";
import { NavBarProvider } from "@hmpu/powerups.ui.nav-bar";
import { LocaleCSSProvider } from '../components/providers/LocaleCSSProvider';
import { BaseFontSize } from '../components/providers/BaseFontSize';
// import { ThemeProvider } from "@hmpu/powerups.config.theme.provider";
import { NotoWebFontProvider } from '@hmpu/powerups.webfonts.noto';
import { ConfigWritingDir } from '../components/providers/ConfigWritingDir';

export const appConfig = {
  components: componentConfig,
  pages: pagesMap,
  pageComponents: pageComponents,
};

console.log('app.ts :: appConfig', appConfig);

export const globalContexts = [
  BaseFontSize,
  // [ThemeProvider, theme], // @2DO: Does this go here in the call order?
  [StoreProvider, {}],
  [IntlProvider, intlConfig],
  ConfigWritingDir,
  // [LocaleCSSProvider, {}],
  [NotoWebFontProvider, {}],
  // [PageConfigProvider, { pageComponents }], 
  [PageConfigProvider, { pagesMap, pageComponents }],
  AudioProvider,
] as any;

export default appConfig;
